<template>
  <section class="content" id="app">
    <div class="anomalies-filters" ref="elFilters">
      <span>Du</span>
      <datepicker class="form-control datepicker-anomalie" language="fr" v-model="fromFilterDate"></datepicker>
      <span>au</span>
      <datepicker class="form-control datepicker-anomalie" language="fr" v-model="toFilterDate"></datepicker>
      <div class="buttons">
        <button type="button"
                v-on:click="filterByDate"
                class="btn btn-primary">Afficher
        </button>
        <button type="button"
                v-on:click="exportAnomalies"
                class="btn btn-secondary blue-button right-padding"><img src="../../../../static/img/btn-export.svg">
          Exporter
        </button>
        <button type="button"
                v-on:click="exportAllAnomalies"
                class="btn btn-secondary blue-button right-padding"><img src="../../../../static/img/btn-export.svg">Exporter
          tous les événements
        </button>
      </div>
    </div>

    <content-row
      v-for="a in paginateAnomalies"
      :is-open="selectedAnomalie.id === a.id"
      @open="openAnomalieDetails(a)"
      @close="closeAnomalieDetails()">

      <div slot="main-close">
        <div class="col-sm-2 right-separator">
          <span class="title-item">TYPE</span>
          <span class="blue-text text-item">{{ a.type }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">RONDE</span>
          <span class="text-item sm break-word">{{ a.nomRonde }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">Tri</span>
          <span class="blue-text text-item">{{ a.qualityTypes[0] ? a.qualityTypes[0] : '-' }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">BAC COLLECTÉ</span>
          <span class="text-item sm break-word">{{ a.bacPresent ? 'Oui' : 'Non' }}</span>
        </div>
        <div class="col-sm-2 break-word">
          <span class="title-item">DATE</span>
          <span class="text-item sm break-word">{{ a.date | fullDateFormatter }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">AGENT</span>
          <span class="text-item sm break-word">{{ a.agentFirstName }} {{ a.agentLastName }}</span>
        </div>
      </div>

      <div slot="main-open">
      <div class="col-sm-2 right-separator">
        <span class="title-item">TYPE</span>
        <span class="blue-text text-item">{{ a.type }}</span>
      </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">RONDE</span>
          <span class="text-item sm break-word">{{ a.nomRonde }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">Tri</span>
          <span class="blue-text text-item">{{ a.qualityTypes[0] ? a.qualityTypes[0] : '-' }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">BAC COLLECTÉ</span>
          <span class="text-item sm break-word">{{ a.bacPresent ? 'Oui' : 'Non' }}</span>
        </div>
        <div class="col-sm-2">
          <span class="title-item">DATE</span>
          <span class="text-item sm break-word">{{ a.date | fullDateFormatter }}</span>
        </div>
        <div class="col-sm-2 right-separator">
          <span class="title-item">AGENT</span>
          <span class="blue-text text-item">{{ a.agentFirstName }} {{ a.agentLastName }}</span>
        </div>
        <div class="col-sm-4 item-details right-separator" style="margin-top: 1%">
          <div>
            <span class="title-item botton-space">ADRESSE</span>
            <span class="blue-text text-item break-word">{{ a.addresse }}</span>
          </div>
        </div>
        <div class="col-sm-8 item-details" style="margin-top: 1%">
          <div>
            <span class="title-item botton-space">IMAGE</span>
            <router-link v-if="a.photos.length > 0" class="action-select"
                         target="_blank"
                         :to="{name: 'Image-anomalie', params: {id: a.photos[0].id}}">
              Consulter l'image
            </router-link>
            <span class="text-item sm break-word" v-show="a.photos.length === 0">Pas d'image</span>
          </div>
        </div>

      </div>

      <div slot="bottom-actions"
           v-if="selectedAnomalie.id === a.id">
      </div>
    </content-row>


    <div class="paginations">
      <button v-on:click="backPagination()" v-show="currentPage > 1" class="btn btn-primary">Précédent</button>
      <span class="text-item">Page {{ currentPage }} sur {{ totalPages }}</span>
      <button v-on:click="nextPagination()" v-show="currentPage < totalPages" class="btn btn-primary">Suivant</button>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import dateFormatter from '../../../utils/dateFormatter'
import timeFormatter from '../../../utils/timeFormatter'
import Papa from '../../../../node_modules/papaparse/papaparse'
import _ from 'lodash'
import ContentRow from '../../shared/ContentRow'
import moment from 'moment'
import agentNameFormatter from '../../../utils/agentNameFormatter'
import state from '../../../store/state'

export default {
  components: {
    Datepicker,
    ContentRow,
  },
  computed: {
    ...mapState([
      'anomalies',
    ]),
  },
  data: function () {
    return {
      fromFilterDate: new Date(),
      toFilterDate: new Date(),
      currentPage: 0,
      totalPages: 0,
      itemsPerPage: 15,
      resultCount: 0,
      paginateAnomalies: [],
      selectedAnomalie: {
        meta: {
          id: null,
        },
      },
    }
  },
  mounted: function () {
    this.filterByDate()
    this.anomalies.anomalie_image = ''
    // this.$store.dispatch('fetchAgents')
  },
  methods: {
    openAnomalieDetails: function (anomalie) {
      this.selectedAnomalie = _.cloneDeep(anomalie)
      console.log("this.selectedAnomalie :: " , this.selectedAnomalie.photos[0].data)
      state.anomalies.anomalie_image = this.selectedAnomalie.photos[0].data
      //this.$store.dispatch('fetchAnomalie', anomalie.meta.id)
    },
    closeAnomalieDetails: function () {
      this.selectedAnomalie.id = null
    },
    paginate: function (list) {
      this.resultCount = list.length
      var index = (this.currentPage - 1) * this.itemsPerPage
      return list.slice(index, index + this.itemsPerPage)
    },
    nextPagination: function () {
      this.currentPage++
      this.paginateAnomalies = this.paginate(this.anomalies.filter.data)
    },
    backPagination: function () {
      this.currentPage--
      this.paginateAnomalies = this.paginate(this.anomalies.filter.data)
    },
    filterByDate: function () {
      this.currentPage = 0
      var that = this
      this.$store.dispatch('searchAnomaliesV2', {
        from: dateFormatter(this.fromFilterDate),
        to: dateFormatter(this.toFilterDate),
      })
        .then((data) => {
          that.resultCount = that.anomalies.filter.data.length
          that.totalPages = Math.ceil(that.resultCount / that.itemsPerPage)
          that.currentPage++
          that.paginateAnomalies = that.paginate(that.anomalies.filter.data)
        })
    },
    exportCsvAllAnomalies: function () {
      this.$store.dispatch('fetchAnomalies').then((response) => {
        this.asignCsvValue(response.results)
      }, function (err) {
        console.error(err)
      })
    },
    makeCSV: function (data) {
      // String.format("%s;%s;%s;%s;%s;%s;%s;%s;SITA", DateFormatter.formatDDMMYYYY(d), DateFormatter.formatHHMM(d), nomRonde, adresse.getVille(), adresse.getNumero(), adresse.getVoie(), anomalieType, isBacSortieShort)
      var content = Papa.unparse({
        encoding: 'UTF-8',
        fields: [
          'Date',
          'Heure',
          'N° Ronde Bom',
          'Commune',
          'N° rue',
          'Adresse',
          'Type évènement',
          'Tri',
          'Collecte',
          'Prestataire',
          'Ronde SC',
          'Agent',
        ],
        data: data,
      })
      this.prompCsvDownload(content)
    },
    asignCsvValue: function (data) {
      var result = data.map(function (value) {
        return {
          'Date': moment(value.date).format('DD/MM/YYYY'),
          'Heure': timeFormatter(value.date),
          'N° Ronde Bom': value.numRonde,
          'Commune': 'LYON 1',
          'N° rue': value.addresse.match(/^\d+/),
          'Adresse': value.addresse,
          'Type évènement': value.type,
          'Tri': value.qualityTypes ? value.qualityTypes[0] : '-',
          'Collecte': value.bacPresent ? 'OUI' : 'NON',
          'Prestataire': 'SITA LYON',
          'Ronde SC': value.nomRonde,
          'Agent': value.agentFirstName + ' ' + value.agentLastName,
        }
      })
      this.makeCSV(result)
    },
    exportAnomalies: async function () {
      await this.$store.dispatch('searchAnomaliesForReportingV2', {
        from: dateFormatter(this.fromFilterDate),
        to: dateFormatter(this.toFilterDate),
      })

      console.log('res to export :: ', this.$store.state.anomalies.reporting)

      this.asignCsvValue(this.$store.state.anomalies.reporting)
    },
    exportAllAnomalies: async function () {
      await this.$store.dispatch('searchAnomaliesForReportingV2', {
        from: '2010-10-01',
        to: dateFormatter(new Date()),
      })

      console.log('res to export :: ', this.$store.state.anomalies.reporting)

      this.asignCsvValue(this.$store.state.anomalies.reporting)
    },
    prompCsvDownload: function (content) {
      var csvData = new window.Blob([
        '\uFEFF' + content, // prepend utf8's BOM fixes excel import it seems
      ], {
        type: 'text/csv;charset=WINDOWS-1252;',
      })
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(csvData, 'suez_anomalies.csv')
      } else {
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(csvData)
        link.setAttribute('download', 'suez_anomalies.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    setSelectedAnomalieId: function (anomalie) {
      if (this.selectedAnomalie.meta.id === anomalie.meta.id) {
        this.selectedAnomalie.meta.id = null
      } else {
        this.selectedAnomalie = _.cloneDeep(anomalie)
      }
    },
    getAgentName (agentId) {
      var agentName = '-'
      this.$store.state.agents.data.map(function (agent) {
        if (agent.meta.id === agentId) {
          agentName = agent.firstname + ' ' + agent.lastname
        }
      })
      return agentName
    },
  },
}
</script>

<style lang="scss">
@import "../../../scss/variables";

.paginations {
  text-align: center;
  margin-top: 20px;

  span {
    margin: 0 20px 0 20px;
  }
}

.anomalies-filters {
  .form-control {
    display: inline-block;
    width: 12%;
    min-width: 115px;

  }

  .buttons {
    display: inline-block;
    vertical-align: top;
    margin-left: 5px;
  }

  margin-bottom: 20px;
}

.title-item {
  font-size: .8em;
  color: grey;
  display: block;
}

.datepicker-anomalie {
  border-radius: 5px;
}

.blue-button {
  background-color: $suez-blue;
  color: white !important;

  img {
    padding-right: 5%;
  }
}

.blue-text {
  color: $suez-blue;
}

.right-padding {
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// AnomaliesList.vue?16c4b0f4